import { createClient } from '@supabase/supabase-js';

// Use the official Supabase credentials provided for this project
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase credentials missing. Ensure VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are set in .env');
}

export const supabase = createClient(
  supabaseUrl || 'https://mfzhbuxoltvjjbzhbtes.supabase.co',
  supabaseAnonKey || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1memhidXhvbHR2ampiemhidGVzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzcxMTY3NzEsImV4cCI6MjA5MjY5Mjc3MX0.eyNBq17FpLKvP5m_AlmpAoK3uXmWY90YTWKbziAfLBk'
);

// Utility to generate unique booking numbers
export const generateBookingNumber = () => {
  const date = new Date();
  const dateStr = `${date.getFullYear().toString().slice(-2)}${(date.getMonth() + 1).toString().padStart(2, '0')}${date.getDate().toString().padStart(2, '0')}`;
  const randomStr = Math.random().toString(36).substring(2, 6).toUpperCase();
  return `MDC-${dateStr}-${randomStr}`;
};